// v3/layouts/AuthLayout.tsx — Login layout
// Dark navy gradient background on all devices.
// Zero imports from v1/v2.

import { Outlet } from 'react-router-dom';

export function AuthLayout() {
  return (
    <div
      className="flex min-h-screen items-center justify-center p-4"
      style={{
        background: 'linear-gradient(135deg, #0f172a 0%, #1e3a5f 50%, #0f172a 100%)',
      }}
    >
      <div className="w-full max-w-sm rounded-xl border bg-white/95 backdrop-blur-sm shadow-lg">
        <Outlet />
      </div>
    </div>
  );
}
